import { BodyPrimary, H3 } from '@liveauctioneers/hammer-ui-core/text';

import { ReviewComment as ReviewCommentType } from '@/types/Review';
import { Seller } from '@/types/Seller';
import { shortFormatDate } from '@/utils/dates';
import { getAuctioneerLogoUrl } from '@/utils/urls';

const getDisplayTime = (time: string) => shortFormatDate(new Date(time));

export type ReviewCommentProps = {
    comment: ReviewCommentType;
    seller: Seller;
};

export const ReviewComment = ({ comment, seller }: ReviewCommentProps) => {
    return (
        <div
            className="flex items-start py-sm"
            key={comment.commentId}
        >
            {Boolean(seller.logoId) && (
                <div className="mr-sm flex h-[44px] w-[44px] items-center justify-center border border-border-secondary bg-background-primary">
                    <img
                        alt={`${seller.name} logo`}
                        className="max-h-[42px] max-w-[42px]"
                        loading="lazy"
                        src={getAuctioneerLogoUrl(seller.logoId, 84)}
                    />
                </div>
            )}
            <div className="mt-xs flex max-w-[630px] flex-col">
                <div className="flex items-baseline smMax:w-full">
                    <H3>{comment.userDisplayName}</H3>
                    <div className="ml-sm align-bottom whitespace-nowrap">
                        <BodyPrimary color="secondary">{getDisplayTime(comment.commentSubmitted)}</BodyPrimary>
                    </div>
                </div>
                <div className="mt-2xs max-w-[630px] smMax:w-full">
                    <BodyPrimary color="secondary">{comment.comment}</BodyPrimary>
                </div>
            </div>
        </div>
    );
};
